import callAPiBase from './base';

const collaboratorsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/companyListUsers',
      method: 'GET',
      useToken: true,
      title: 'Collaborator - Get list',
      params,
    }),
  create: ({ data, companyId }: { data: Array<object>; companyId?: string }) =>
    callAPiBase({
      endpoint: '/companyAddUsers',
      method: 'POST',
      useToken: true,
      title: 'Collaborator - Create',
      data: { users: data, authUserId: companyId },
    }),
  linkUserToCompany: ({
    users,
    authUserId,
  }: {
    users: Array<{
      id: string;
    }>;
    authUserId?: string;
  }) =>
    callAPiBase({
      endpoint: '/companyAddUsers',
      method: 'POST',
      useToken: true,
      title: 'Collaborator - Link to Company',
      data: { users, authUserId },
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyUpdateUsers',
      method: 'POST',
      useToken: true,
      title: 'Collaborator - Update',
      data,
    }),
  delete: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/companyDeleteUsers',
      method: 'POST',
      useToken: true,
      title: 'Collaborator - Delete',
      data,
    }),
  unlinkUserFromCompany: ({
    users,
    authUserId,
  }: {
    users: Array<{
      id: string;
    }>;
    authUserId?: string;
  }) =>
    callAPiBase({
      endpoint: '/companyDeleteUsers',
      method: 'POST',
      useToken: true,
      title: 'Collaborator - unlinkUserFromCompany',
      data: { users, authUserId },
    }),
};

export { collaboratorsApi };
export default collaboratorsApi;
